export default __webpack_public_path__ + "media/images/react_icons/cart-764e911cd56a7ee07be43c639cad7d4d.svg";